<div (click)="$event.preventDefault(); closeModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4">
    <div class="w-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 rounded-md text-center shadow-lg">
            <form (ngSubmit)="$event.preventDefault(); save();" #kitForm="ngForm"
                class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between pb-4 border-b border-gray-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap text-nside-orange-400">
                        {{ isEdit ? 'Edit Evacuation Kit' : 'Add an Evacuation Kit' }}
                    </h2>
                    <button class="p-1 rounded-full hover:bg-gray-100" (click)="$event.preventDefault(); closeModal();">
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>

                <div class="w-full flex flex-col items-center justify-center gap-3 pb-4 border-b border-gray-200">
                    <!-- Name -->
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input type="text" name="name" [(ngModel)]="kit.name" required
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Name">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="kitForm.submitted && !kit.name">
                                This field is required.
                            </div>
                        </div>
                    </div>

                    <!-- Location -->
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Location:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input type="text" name="location" [(ngModel)]="kit.location" required
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="Location">
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="kitForm.submitted && !kit.location">
                                This field is required.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button (click)="$event.preventDefault(); closeModal();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font">
                        Close
                    </button>
                    <button type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isValid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isValid
                        }"
                        [disabled]="!isValid">
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>
